import { useState } from "react";
import { useAuth, ROLES } from "@/lib/auth";
import { fmtDateTime } from "@/lib/format";
import { User as UserIcon, ShieldAlert } from "lucide-react";
import ResetPanel from "@/pages/ResetPanel";

const Info = ({ label, value }) => (
  <div>
    <div className="text-[11px] uppercase tracking-wider text-[#6B7280] font-bold">{label}</div>
    <div className="text-sm font-semibold text-[#111827]">{value || "-"}</div>
  </div>
);

const TabBtn = ({ id, label, icon: Icon, active, onClick, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
      active
        ? "bg-[#0B3676] text-white"
        : "bg-white text-[#6B7280] border border-[#E5E7EB] hover:border-[#0B3676]"
    }`}
  >
    <Icon size={16} /> {label}
  </button>
);

export default function Settings() {
  const { user } = useAuth();
  const [tab, setTab] = useState("profile");
  if (!user) return null;
  const isAdmin = user.role === "admin";

  return (
    <div className="max-w-6xl space-y-5">
      <div className="flex flex-wrap gap-2">
        <TabBtn id="profile" label="Profilim" icon={UserIcon}
                active={tab === "profile"} onClick={() => setTab("profile")}
                testid="settings-tab-profile" />
        {isAdmin && (
          <TabBtn id="reset" label="SIFIRLA" icon={ShieldAlert}
                  active={tab === "reset"} onClick={() => setTab("reset")}
                  testid="settings-tab-reset" />
        )}
      </div>

      {tab === "profile" && (
        <div className="max-w-3xl space-y-5">
          <div className="azd-card p-6">
            <div className="flex items-center gap-4 mb-5">
              <div className="w-16 h-16 rounded-xl bg-[#08285A] text-white flex items-center justify-center text-2xl font-extrabold">
                {user.full_name?.[0]}
              </div>
              <div>
                <div className="text-xl font-extrabold text-[#08285A]">{user.full_name}</div>
                <div className="text-sm text-[#6B7280]">{ROLES[user.role]} • {user.email}</div>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <Info label="E-Posta" value={user.email} />
              <Info label="Rol" value={ROLES[user.role]} />
              <Info label="Şirket Telefonu" value={user.company_phone} />
              <Info label="Şahsi Telefon" value={user.personal_phone} />
              <Info label="Doğum Tarihi" value={user.birth_date} />
              <Info label="Kan Grubu" value={user.blood_type} />
              <Info label="Acil Durum Kontak" value={user.emergency_contact_name} />
              <Info label="Acil Durum Telefon" value={user.emergency_contact_phone} />
              <Info label="Son Giriş" value={user.last_login_at ? fmtDateTime(user.last_login_at) : "-"} />
            </div>
            {user.address && (
              <div className="mt-4 pt-4 border-t border-[#E5E7EB]">
                <Info label="Adres" value={user.address} />
              </div>
            )}
          </div>

          <div className="azd-card p-6">
            <div className="text-sm font-bold text-[#08285A] mb-2 uppercase tracking-wider">
              Şifre Değişikliği
            </div>
            <p className="text-sm text-[#6B7280]">
              Şifrenizi değiştirmek için lütfen sistem yöneticinizle iletişime geçin.
              Güvenlik politikası gereği &quot;şifremi unuttum&quot; özelliği bulunmamaktadır.
            </p>
          </div>
        </div>
      )}

      {tab === "reset" && isAdmin && <ResetPanel />}
    </div>
  );
}
